import React from "react";
import { Trans, useTranslation } from "react-i18next";
import * as globals from "../../../src/styles/global.icss.scss";
import {
	ReleaseChannel,
	DFUImage,
	parseDFUName,
	VelavuDevice,
} from "velavu-js-api";
import IconArrowDropRight from "../../dynamicicons/icon-arrow-drop-right";
import IconWarning from "../../dynamicicons/icon-warning";
import Divider from "../../elements/divider";
import VelavuButton from "../../elements/velavu-button";
import * as styles from "./tab-tag-dfu-install-modal.module.scss";
import VelavuModalContainer from "../../elements/velavu-modal-container";
import VelavuNotice from "../../elements/velavu-notice/velavu-notice";
export default function TabTagDFUInstallModal(props: {
	tag: VelavuDevice;
	image: DFUImage;

	onConfirm?: VoidFunction;
	onCancel?: VoidFunction;
}) {
	const { t } = useTranslation();
	const currentVersionName = props.tag.state?.app_version;
	const currentVersion =
		currentVersionName !== undefined
			? parseDFUName(currentVersionName).version
			: undefined;

	return (
		<VelavuModalContainer className={styles.container}>
			<span className={styles.title}>
				{t("asset_detail.dfu.install.title")}
			</span>
			<Divider />
			<div className={styles.innerContainer}>
				<span className={styles.textPrimary}>{props.tag.id}</span>

				<div className={styles.versionRow}>
					{currentVersion !== undefined ? (
						<>
							<span className={styles.textPrimary}>
								{currentVersion}
							</span>
							<IconArrowDropRight color={globals.textPrimary} />
							<span className={styles.textPrimary}>
								{props.image.version}
							</span>
						</>
					) : (
						<span className={styles.textPrimary}>
							{props.image.version}
						</span>
					)}
				</div>

				<span className={styles.textSecondary}>
					{props.image.comment}
				</span>
			</div>

			{props.image.channel === ReleaseChannel.Beta && (
				<VelavuNotice className={styles.notice} type="info">
					{t("asset_detail.dfu.install.beta_notice")}
				</VelavuNotice>
			)}

			{props.image.channel === ReleaseChannel.Alpha && (
				<VelavuNotice className={styles.notice} type="warning">
					<Trans
						i18nKey="asset_detail.dfu.install.alpha_notice"
						components={{
							emphasis: (
								<span className={styles.noticeEmphasis} />
							),
						}}
					/>
				</VelavuNotice>
			)}

			<div className={styles.buttonRow}>
				<VelavuButton
					className={styles.buttonRowButton}
					label={t("common.cancel")}
					variant="outlined"
					fullWidth
					onClick={props.onCancel}
				/>
				<div className={styles.buttonRowSpacer} />
				<VelavuButton
					className={styles.buttonRowButton}
					label={t("asset_detail.dfu.install.confirm")}
					fullWidth
					onClick={props.onConfirm}
				/>
			</div>
		</VelavuModalContainer>
	);
}
